export function formatBytes(n: number) {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}

const inr = (n: number) => `₹${n.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;

/**
 * A plan's price as the website shows it (design W4): the yearly price as a
 * per-month figure, "billed yearly"; else the monthly-billing price; else "Talk to us".
 */
export function formatPlanPrice(p: { price_yearly_inr: string | number | null; price_monthly_inr: string | number | null }) {
  if (p.price_yearly_inr != null && p.price_yearly_inr !== '') {
    const y = Number(p.price_yearly_inr);
    return `${inr(Math.round(y / 12))}/month, billed yearly (${inr(y)}/year)`;
  }
  if (p.price_monthly_inr != null && p.price_monthly_inr !== '') return `${inr(Number(p.price_monthly_inr))}/month`;
  return 'Talk to us';
}
